<template>
    <div>
        <div class="home" v-common-display>
            <div>
                <div class="homeTitle">wh系列软件</div>
                <div class="homeSoft">
                    <!-- <div class="softBox">
                        <router-link to="/detail/139">
                            <div class="softImg"><img src="@/assets/image/wh3_logo.png" alt=""></div>
                            <div class="introduce">
                                <h2><common-data name="appFullName_38"/><common-data name="appShortName_38"/></h2>
                                <p>提供4000+只股票的估值数据，以及估值线、买卖点等价格研究工具。</p>
                                <router-link to="/detail/139" class="tobuy">去购买&gt;</router-link>
                            </div>
                        </router-link>
                    </div> -->
                    <div class="softBox">
                        <router-link to="/detail/129">
                            <div class="softImg"><img src="@/assets/image/wh5.png" alt=""></div>
                            <div class="introduce">
                                <h2><common-data name="appFullName_26"/><common-data name="appShortName_26"/></h2>
                                <p>提供4000+只股票的估值数据，以及估值线等价格研究工具。</p>
                                <router-link to="/detail/129" class="tobuy">去购买&gt;</router-link>
                            </div>
                        </router-link>
                    </div>
                    <div class="softBox">
                        <router-link to="/detail/76">
                            <div class="softImg"><img src="@/assets/image/logo_wh7.png" alt=""></div>
                            <div class="introduce">
                                <h2><common-data name="appFullName_12"/><common-data name="appShortName_12"/></h2>
                                <p>小文研报、小文估值、期货/期权折算估值等价格研究工具，套利、移仓、网格等策略交易工具。</p>
                                <router-link to="/detail/76" class="tobuy">去购买&gt;</router-link>
                            </div>
                        </router-link>
                    </div>
                    <!-- <div class="softBox" style="margin-top: 50px;">
                        <router-link to="/detail/110">
                            <div class="softImg"><img src="@/assets/image/wh10_logo.png" alt=""></div>
                            <div class="introduce">
                                <h2><common-data name="appFullName_40"/><common-data name="appShortName_40"/></h2>
                                <p>提供4000+只股票的估值数据，以及估值线、买卖点等价格研究工具。</p>
                                <router-link to="/detail/110" class="tobuy">去购买&gt;</router-link>
                            </div>
                        </router-link>
                    </div> -->
                </div>
            </div>
            <div>
                <div class="homeTitle">WT系列软件</div>
                <div class="homeSoft">
                    <div class="softBox">
                        <router-link to="/detail/1">
                            <div class="softImg"><img src="@/assets/image/logo_T8.png" alt=""></div>
                            <div class="introduce">
                                <h2><common-data name="appFullName_11"/><common-data name="appShortName_11"/></h2>
                                <p>基于技术指标的趋势策略开发、自动交易，麦语言积木式编程环境、历史数据、期货交易接口。</p>
                                <router-link to="/detail/1" class="tobuy">去购买&gt;</router-link>
                            </div>
                        </router-link>
                    </div>
                    <div class="softBox">
                        <router-link to="/detail/124">
                            <div class="softImg"><img src="@/assets/image/logo_T9.png" alt=""></div>
                            <div class="introduce">
                                <h2><common-data name="appFullName_17"/><common-data name="appShortName_17"/></h2>
                                <p>支持趋势策略、订单流策略、算法下单组件的开发，服务于金工、投资经理、交易员等各种角色的工作需求。</p>
                                <router-link to="/detail/124" class="tobuy t9">去购买&gt;</router-link>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div>
                <div class="homeTitle">策略终端</div>
                <div class="homeSoft">
                    
                    <div class="softBox">
                        <router-link to="/detail/138">
                            <div class="softImg"><img src="@/assets/image/logo_wh11.png" alt=""></div>
                            <div class="introduce">
                                <h2><common-data name="appFullName_37"/><common-data name="appShortName_37"/></h2>
                                <p>估值数据库的应用平台，引用估值数据、技术指标、财务数据、市场情绪等各类因子，构建量化多头、市场中性等策略。</p>
                                <router-link to="/detail/138" class="tobuy" style="margin-top: 0;">去购买&gt;</router-link>
                            </div>
                        </router-link>
                    </div>
                    <div class="softBox">
                        <router-link to="/detail/131">
                            <div class="softImg"><img src="@/assets/image/logo_wh12.png" alt=""></div>
                            <div class="introduce">
                                <h2><common-data name="appFullName_29"/><common-data name="appShortName_29"/></h2>
                                <p>估值数据库的应用平台，引用估值数据、宏观、盈利预期、公告事件等各类因子，构建风险控制策略。也支持商品CTA投资策略。</p>
                                <router-link to="/detail/131" class="tobuy" style="margin-top: 0;">去购买&gt;</router-link>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div style="padding-bottom: 50px;">
                <div class="homeTitle">周边产品</div>
                <div class="homeSoft" style="margin-bottom: 0;">
                    <div class="softBox" style="height: 107px;padding-top: 40px;">
                        <img src="@/assets/image/peripheral.png" class="peripheralImg" alt="">
                        <div class="peripheral">
                            <!-- <router-link to="/detail/44">模型编写视频教程&gt;</router-link> -->
                            <!-- <router-link to="/detail/18">下单专用键盘&gt;</router-link> -->
                            <router-link to="/detail/136">模型编写视频教程&gt;</router-link>
                            <!-- <router-link to="/detail/132">2026年台历&gt;</router-link> -->
                            <router-link to="/detail/27">其他支付金额&gt;</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="product_box"> -->
                <!-- <div class="product_item _7e" editHashId="39dec5c9b877a">
                    <div class="hot"></div>
                    <div class="title">7E基础功能包</div>
                    <div class="text">可以选配多账号下单、套利下单、收费数据</div>
                    <div class="price">￥1200元/年/账号</div>
                </div>
                <div class="product_item _8c" editHashId='bedf41bce1941'>
                    <div class="hot"></div>
                    <div class="title">市场保有率最高量化交易软件</div>
                    <div class="text">电脑交易员，构建自己的交易机器人，实现0手动下单</div>
                    <div class="price">￥7800元/年/账号</div>
                </div>
                <div class="product_item _9b" editHashId='f26d8fb27ee40'>
                    <div class="hot"></div>
                    <div class="title">高端算法交易软件</div>
                    <div class="text">提高交易效率，减少成交滑点的交易利器</div>
                    <div class="price">￥12000元/年/账号</div>
                </div>
                <div class="product_item cloud" editHashId='d4f3a8722a362'>
                    <div class="hot"></div>
                    <div class="title">量化交易顶级配套装备</div>
                    <div class="text">量化交易不断电，行情、交易无阻极速</div>
                    <div class="price">￥12000元/年/账号</div>
                </div> -->
                <!-- <div class="product_item" v-for='(item,index) in list' @click="click(item)" :style="{background: `url(${item.image}) no-repeat top center`}" :key='index'></div>
                <div style="clear: both;"></div> 
            </div>-->
        </div>
        <div class="leftNav">
            <a class="how_link" v-common-display @click="howToChoose"><common-data name="appShortName_12"/>/<common-data name="appShortName_11"/>/<common-data name="appShortName_17"/>,我该选哪个软件？</a>
            <div class="qr_code">
                微信公众号文华财经
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'Home',
        components: {

        },
        data: ()=>({
            list: []
        }),
        methods: {
            howToChoose() {
                this.$market.openFreame({
                    url: '/#/softIntroduction'
                })
            },
            click (item) {
                this.$router.push({path: '/Detail/'+item.productId})
            }
        },
        mounted () {
            
            this.$axios({
                url: "/api/Home/HomeIndex",
                method: "get"
            })
            .then(res => {
               this.list = res.data
            })
        },
        activated () {
            
        },
        watch: {
            '$route': {
                handler (val,old) {
                    
                },
                immediate: true
            }
        }
    }
</script>

<style scoped>
    .home{
        width: 1270px;
        margin: 0 auto;
    }
    .homeTitle{
        font-size: 23px;
        color: #232E3D;
        padding-left: 14px;
        position: relative;
        line-height: 36px;
    }
    .homeTitle::before{
        content: "";
        display: block;
        width: 6px;
        height: 20px;
        background-color: #FF9D5B;
        position: absolute;
        left: 0;
        top: 8px;
    }
    .homeSoft{
        margin-top: 24px;
        margin-bottom: 48px;
        width: 1340px   ;
    }
    .softBox{
        height: 162px;
        width: 304px;
        padding: 27px 40px 0;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 2px;
        box-shadow: rgba(159, 184, 209, 0.92) 0 0 4px;
        margin-right: 59px;
        position: relative;
        clear: both;
        transition: all .2s ease-out;
        filter: drop-shadow(0 3px 4px rgba(0,0,0,.1));
        display: inline-block;
    }
    .softBox:last-child{
        margin-right: 0;
    }
    .softBox:hover{
        transform: translateY(-6px);
        filter: drop-shadow(0 15px 10px rgba(0, 0, 0, 0.16));
    }
    .softImg{
        width: 62px;
        padding-top: 3px;
        float: left;
    }
    .introduce{
        margin-left: 27px;
        width: 215px;
        float: left;
        text-align: justify;
    }
    .introduce h2{
        font-size: 18px;
        color: #333333;
        font-weight: normal;
        margin: 0;
        line-height: 24px;
        white-space: nowrap;
    }
    .introduce p{
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin-top: 18px;
    }
    .tobuy{
        font-size: 12px;
        color: #0066FF;
        float: right;
        margin-top: 21px;
    }
    .tobuy.t9 {
        margin-top: 0;
    }
    .peripheralImg{
        position: absolute;
        left: 14px;
        top: -13px;
    }
    .peripheral{
        margin-left: 193px;
        margin-top: -8px;
    }
    .peripheral a{
        color: #0066FF;
        font-size: 14px;
        line-height: 30px;
        display: block;
        white-space: nowrap;
    }
    .leftNav{
        width: 175px;
        position: absolute;
        left: 0;
        top: 0;
        white-space: nowrap;
    }
    .how_link {
        font-size: 13px;
        color: #0066FF;
        cursor: pointer;
        display: block;
        line-height: 27px;
        height: 27px;
        margin-top: 265px;
        margin-bottom: 20px;
    }

    .how_link::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 27px;
        background: url(../../assets/image/why_icon.png) no-repeat center left;
    }
    .qr_code {
        text-align: center;
        color: #666;
        line-height: 18px;
        padding-top: 78px;
        margin-top: 102px;
        background: url(../../assets/image/qr_code.png) no-repeat center top;
    }


    .product_box {
        width: 888px;
        /* overflow: hidden; */
        margin: 72px auto 0;
    }
    .product_item {
        width: 432px;
        height: 236px;
        float: left;
        margin-right: 24px;
        margin-bottom: 24px;
        position: relative;
        z-index: 50;
        cursor: pointer;
        transition: all .2s ease-out;
        filter: drop-shadow(0 3px 4px rgba(0,0,0,.1));
    }
    .product_item:nth-of-type(2),.product_item:nth-of-type(4){
        margin-right: 0;
    }
    .product_item:hover{
        transform: translateY(-6px);
        filter: drop-shadow(0 15px 10px rgba(0, 0, 0, 0.16));
    }
    .product_item .hot{
        width: 33px;
        height: 16px;
        background: url(../../assets/image/R01.png) no-repeat;
        position: absolute;
        left: 29px;
        top: 94px;
    }
    
    .product_item .price{
        width: 160px;
        height: 35px;
        line-height: 35px;
        box-sizing: border-box;
        padding-left: 20px;
        font-size: 14px;
        color: white;
        background: url(../../assets/image/product_price.png) no-repeat;
        position: absolute;
        right: 4px;
        bottom: 6px;
    }
    .product_item .title {
        position: absolute;
        left: 29px;
        top: 147px;
        color: rgb(42, 49, 57);
        font-family: '宋体';
    }
    .product_item .text {
        position: absolute;
        left: 29px;
        top: 174px;
        width: 180px;
        color: rgb(104, 105, 107);
        font-family: '宋体';
    }
</style>